import { Box, FunctionSquareIcon, Landmark } from 'lucide-react';
import { useParams } from 'react-router';

import { AsvIcons } from '@components/features/AsvScans/Icons';
import { Command, useCommandMenu } from '@components/features/CommandMenu';
import { useResources } from '@components/features/DataRoles/useResources';
import { DomainIcon } from '@components/features/Relays/DomainIcon';

export function ResourceCommands() {
  const { isOpen } = useCommandMenu();
  return isOpen ? <LoadResourceCommands /> : null;
}

function LoadResourceCommands() {
  const resources = useResources();
  const { teamUuid, appUuid } = useParams();

  return (
    <>
      {resources.relays.map((relay) => (
        <Command
          key={relay.id}
          id={relay.id}
          type="route"
          href={`/${teamUuid}/${appUuid}/relays/${relay.id}`}
          label={relay.destinationDomain}
          sublabel="Relay"
          keywords={['relay', relay.id]}
          icon={<DomainIcon domain={relay.destinationDomain} size={16} />}
          filterable
          searchable="only"
          group="Go to..."
          context="app"
        />
      ))}

      {resources.functions.map((func) => (
        <Command
          key={func.uuid}
          id={func.uuid}
          type="route"
          href={`/${teamUuid}/${appUuid}/functions/${func.name}`}
          label={func.name}
          sublabel="Function"
          keywords={['function', func.uuid]}
          icon={<FunctionSquareIcon />}
          filterable
          searchable="only"
          group="Go to..."
          context="app"
        />
      ))}

      {resources.enclaves.map((enclave) => (
        <Command
          key={enclave.uuid}
          id={enclave.uuid}
          type="route"
          href={`/${teamUuid}/${appUuid}/enclaves/${enclave.uuid}`}
          label={enclave.name}
          sublabel="Enclave"
          keywords={['enclave', enclave.uuid]}
          icon={<Box />}
          filterable
          searchable="only"
          group="Go to..."
          context="app"
        />
      ))}

      {resources.origins.map((origin) => (
        <Command
          key={origin.uuid}
          id={origin.uuid}
          type="route"
          href={`/${teamUuid}/${appUuid}/compliance/${origin.uuid}`}
          label={origin.name}
          sublabel="Page"
          keywords={['page protection', origin.uuid]}
          icon={<DomainIcon domain={origin.origin} size={16} />}
          filterable
          searchable="only"
          group="Go to..."
          context="app"
        />
      ))}

      {resources.merchants.map((merchant) => (
        <Command
          key={merchant.id}
          id={merchant.id}
          type="route"
          href={`/${teamUuid}/${appUuid}/payments/merchants/${merchant.id}`}
          label={merchant.name}
          sublabel="Merchant"
          keywords={['merchant', merchant.id]}
          icon={<DomainIcon domain={merchant.website} size={16} />}
          filterable
          searchable="only"
          group="Go to..."
          context="app"
        />
      ))}

      {resources.acquirers.map((acquirer) => (
        <Command
          key={acquirer.id}
          id={acquirer.id}
          type="route"
          href={`/${teamUuid}/${appUuid}/payments/acquirers/${acquirer.id}`}
          label={acquirer.name}
          sublabel="Acquirer"
          keywords={['acquirer', acquirer.id]}
          icon={<Landmark size={16} />}
          filterable
          searchable="only"
          group="Go to..."
          context="app"
        />
      ))}

      {resources.targets.map((target) => (
        <Command
          key={target.id}
          id={target.id}
          type="route"
          href={`/${teamUuid}/${appUuid}/asv/targets/${target.id}`}
          label={target.name}
          sublabel="Target"
          keywords={['target', target.id]}
          icon={<AsvIcons.Target />}
          filterable
          searchable="only"
          group="Go to..."
          context="app"
        />
      ))}
    </>
  );
}
